import { render } from "./OwnerApp.vue?vue&type=template&id=17566f80&scoped=true"
import script from "./OwnerApp.vue?vue&type=script&lang=js"
export * from "./OwnerApp.vue?vue&type=script&lang=js"

import "./OwnerApp.vue?vue&type=style&index=0&id=17566f80&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17566f80"]])

export default __exports__